import { render, staticRenderFns } from "./CompanySettingsLoyalty.vue?vue&type=template&id=d8beb7fc&scoped=true"
import script from "./CompanySettingsLoyalty.vue?vue&type=script&lang=js"
export * from "./CompanySettingsLoyalty.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsLoyalty.vue?vue&type=style&index=0&id=d8beb7fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8beb7fc",
  null
  
)

export default component.exports